import { routes as Login } from '@/views/login'

export default [
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('./Auth.vue'),
    children: [...Login],
  },
]
